var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfinishedCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 146",
    style: {
      enableBackground: "new 0 0 110 146"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.1,34.24c-12.1,0-21.9,9.81-21.9,21.9c0,12.1,9.81,21.9,21.9,21.9c12.09,0,21.9-9.81,21.9-21.9 C74,44.04,64.19,34.24,52.1,34.24z M56.6,56.14l7.98,7.98l-4.51,4.51l-7.98-7.98l-7.98,7.98l-4.51-4.51l7.98-7.98l-7.98-7.98 l4.51-4.51l7.98,7.98l7.98-7.98l4.51,4.51L56.6,56.14z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Paper"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.71,29.7H85.76c-1.81,0-3.29-1.72-3.29-3.83v-9.86c0-6.95-5.4-12.59-12.05-12.59H15.66c-6.65,0-12.05,5.65-12.05,12.59 v115.01c0,6.95,5.4,12.6,12.05,12.6h81.05c6.65,0,12.05-5.65,12.05-12.6V42.29C108.76,35.35,103.36,29.7,96.71,29.7z M100,131.01 c0,2.11-1.48,3.83-3.29,3.83H15.66c-1.81,0-3.29-1.72-3.29-3.83V16.01c0-2.11,1.48-3.83,3.29-3.83h54.77 c1.81,0,3.28,1.72,3.28,3.83v9.86c0,6.95,5.4,12.59,12.05,12.59h10.95c1.81,0,3.29,1.72,3.29,3.83V131.01z M86.85,91.04H25.52 c-2.42,0-4.38,1.96-4.38,4.38c0,2.42,1.96,4.38,4.38,4.38h61.34c2.42,0,4.38-1.96,4.38-4.38C91.23,93,89.27,91.04,86.85,91.04z  M86.85,108.56H25.52c-2.42,0-4.38,1.96-4.38,4.38c0,2.42,1.96,4.38,4.38,4.38h61.34c2.42,0,4.38-1.96,4.38-4.38 C91.23,110.52,89.27,108.56,86.85,108.56z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfinishedCourse);
export default __webpack_public_path__ + "static/media/unfinishedCourse.2edce8c826c43a11f665826370995bd3.svg";
export { ForwardRef as ReactComponent };